import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Programs", path: "/programs" },
  { label: "Community", path: "/community" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Monetize", path: "/payment" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-18 py-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/64d067dc58cbae89e71ec40faad2636e/deaaf3708287f522a170a22cd3f29889.jpeg"
            alt="Mind Odyssey Logo"
            className="w-10 h-10 rounded-full object-cover"
          />
          <span
            className={`font-bold text-lg tracking-tight transition-colors ${
              scrolled || !isHome ? "text-gray-900" : "text-white"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Mind Odyssey
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? scrolled || !isHome
                    ? "text-teal-600"
                    : "text-teal-300"
                  : scrolled || !isHome
                  ? "text-gray-600 hover:text-teal-600"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/register"
            className={`text-sm font-medium px-4 py-2 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
              scrolled || !isHome
                ? "border-gray-300 text-gray-700 hover:border-teal-500 hover:text-teal-600"
                : "border-white/40 text-white hover:border-white"
            }`}
          >
            Sign In
          </Link>
          <Link
            to="/register"
            className="text-sm font-semibold px-5 py-2 rounded-full bg-teal-600 text-white hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Get Started
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled || !isHome ? "text-gray-700" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-medium cursor-pointer ${
                location.pathname === link.path ? "text-teal-600" : "text-gray-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex flex-col gap-2 pt-2 border-t border-gray-100">
            <Link
              to="/register"
              onClick={() => setMenuOpen(false)}
              className="text-sm font-medium text-center py-2 rounded-full border border-gray-300 text-gray-700 cursor-pointer whitespace-nowrap"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              onClick={() => setMenuOpen(false)}
              className="text-sm font-semibold text-center py-2 rounded-full bg-teal-600 text-white cursor-pointer whitespace-nowrap"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
